import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "width": 600,
      "data-sign": "shop_mapping_add_edit_modal",
      "title": _vm.title
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "data-sign": "shop_mapping_add_edit_form",
      "label-col": {
        span: 8
      },
      "wrapper-col": {
        span: 14
      },
      "rules": _vm.formDataRule,
      "model": _vm.formData
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5E97\u94FA"),
      "prop": "shop_code",
      "label": _vm.t('店铺')
    }
  }, [_c('my-select', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "show-search": "",
      "option-filter-prop": "children",
      "placeholder": _vm.t('请选择店铺'),
      "disabled": _vm.isEdit
    },
    on: {
      "change": _vm.handleShopChange
    },
    model: {
      value: _vm.formData.shop_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "shop_code", $$v);
      },
      expression: "formData.shop_code"
    }
  }, _vm._l(_vm.shopList, function (item) {
    return _c('a-select-option', {
      key: item.shop_code,
      attrs: {
        "value": item.shop_code
      }
    }, [_vm._v(" " + _vm._s(item.shop_code) + " " + _vm._s(item.shop_name) + " ")]);
  }), 1)], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4E1A\u52A1\u53D1\u751F\u56FD"),
      "prop": "country_code_list",
      "label": _vm.t('业务发生国')
    }
  }, [_c('my-select', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "mode": "multiple",
      "show-search": "",
      "option-filter-prop": "children",
      "maxTagCount": 1,
      "allowClear": "",
      "placeholder": _vm.t('请选择国家')
    },
    model: {
      value: _vm.formData.country_code_list,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "country_code_list", $$v);
      },
      expression: "formData.country_code_list"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('a-select-option', {
      key: item.country_code,
      attrs: {
        "value": item.country_code
      }
    }, [_vm._v(" " + _vm._s(item.country_code) + " " + _vm._s(item.country_name) + " ")]);
  }), 1), _c('span', {
    staticClass: "note-tip"
  }, [_vm._v(_vm._s(_vm.t('该客户已启用的国家，支持多选')))])], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u7ED1\u5B9A\u4E3B\u4F53"),
      "prop": "account_code",
      "label": _vm.t('绑定主体')
    }
  }, [_c('a-input', {
    attrs: {
      "value": _vm.formData.bind_body_text,
      "disabled": ""
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426\u8BE5\u56FD\u9ED8\u8BA4\u7ED3\u7B97\u4E3B\u4F53"),
      "prop": "is_default",
      "label": _vm.t('是否该国默认结算主体')
    }
  }, [_c('a-switch', {
    attrs: {
      "disabled": _vm.isEdit,
      "checked-children": _vm.t('是'),
      "un-checked-children": _vm.t('否'),
      "checked-value": _vm.$enum.common.BoolIntEnum.YES,
      "un-checked-value": _vm.$enum.common.BoolIntEnum.NO
    },
    model: {
      value: _vm.formData.is_default,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "is_default", $$v);
      },
      expression: "formData.is_default"
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "shop_mapping_add_edit_cancel",
      "id": "shop_mapping_add_edit_cancel",
      "data-sign": "shop_mapping_add_edit_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading,
      "data-permission": "shop_mapping_add_edit_confirm",
      "id": "shop_mapping_add_edit_confirm",
      "data-sign": "shop_mapping_add_edit_confirm",
      "fbu-analyse-name": $t("\u786E\u8BA4")
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('确认')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };